module.exports = __webpack_public_path__ + "7e54b57df50934ae13526b58f3b9ed5f.pdf";